import { render, staticRenderFns } from "./ReadonlyViewCompany.vue?vue&type=template&id=0b2211bd&scoped=true"
import script from "./ReadonlyViewCompany.vue?vue&type=script&lang=js"
export * from "./ReadonlyViewCompany.vue?vue&type=script&lang=js"
import style0 from "./ReadonlyViewCompany.vue?vue&type=style&index=0&id=0b2211bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2211bd",
  null
  
)

export default component.exports